import logo from "./Assets/SKLogo.svg";

import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <a href="*">
          <img src={logo} className="h-sk-logo" alt="logo" />
        </a>
      </header>
    </div>
  );
}

export default App;
